<template>
  <v-row dense class="mb-2">
    <v-col cols="12" sm="4">
      <v-select
        :value="equipe"
        :items="candidatos"
        :disabled="disabledEquipe"
        label="Equipe"
        outlined
        dense
        item-text="nome_completo"
        item-value="idcandidato"
        @change="$emit('update:equipe', $event)"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="4">
      <v-select
        :value="meta"
        :items="metas"
        label="Meta"
        outlined
        dense
        item-text="descricao"
        item-value="idmeta"
        @change="$emit('update:meta', $event)"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="4" class="d-flex align-center justify-end">
      <v-btn color="primary" rounded small @click="$emit('refresh')">
        <v-icon left>mdi-refresh</v-icon>
        Atualizar
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DashboardFiltros",
  props: {
    equipe: {
      type: [String, Number],
      required: true,
    },
    meta: {
      type: [String, Number],
      required: true,
    },
    candidatos: {
      type: Array,
      default: () => [],
    },
    metas: {
      type: Array,
      default: () => [],
    },
    disabledEquipe: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* Estilos específicos do componente (se necessário no futuro) */
</style>
